import { Button } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import Paper from "@mui/material/Paper";
import React, { useState } from "react";
import { ReactComponent as Logo } from "assets/Svgs/logo.svg";

import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useBoundStore } from "store/store";
import i18n from "i18n/i18n";
import LoginWrapper from "components/LoginWrapper";

const SetPassword = () => {
  // const lang = useBoundStore((state) => state.lang);

  let lang = navigator?.language.split("-")[0]; // e.g "de" from de-DE


  let { token } = useParams();

  const [input, setinput] = useState<any>({});
  const [errors, seterrors] = useState<any>({});

  const [error, seterror] = useState(false);

  const [values, setValues] = React.useState<any>({
    showPassword: false,
  });

  const setPassword = useBoundStore((store) => store.setPassword);
  const isAuthUser = useBoundStore((store) => store.isAuthUser);

  const navigate = useNavigate();

  const handleChange = (event: any) => {
    let Input: any = input;
    Input[event.target.name] = event.target.value;
    setinput(Input);
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    if (validate()) {
      const body = { token: token, password: input["password"] };

      const promises: any[] = [setPassword(body)];

      try {
        const result = await Promise.all(promises);
        setTimeout(() => {
          navigate("/login?status=0");
        }, 2000);
      } catch (error) {
        console.error("Error during Promise.all:", error);
        // Handle the error appropriately
      }
    }
  };

  const validate = () => {
    seterror(false);
    let Input: any = input;
    let errors: any = {};
    let isValid = true;

    if (!Input["password"]) {
      isValid = false;
      errors["password"] = i18n(lang).error_password_required;
      seterror(true);
    }

    if (!Input["confirm_password"]) {
      isValid = false;
      errors["confirm_password"] = i18n(lang).error_confirm_password;
      seterror(true);
    }

    if (
      typeof Input["password"] !== "undefined" &&
      typeof Input["confirm_password"] !== "undefined"
    ) {
      if (Input["password"] != Input["confirm_password"]) {
        isValid = false;
        errors["password"] = i18n(lang).pass_not_match;
        seterror(true);
      }
    }

    seterrors(errors);

    return isValid;
  };

  return (
    <>
      <LoginWrapper
        showLogo={true}
        // showBanner={query.get("status")}
        // bannerContent={bannerJson[Number(query.get("status"))]}
      >
        <div className="content"  style={{ textAlign: "center"}}>
          <Typography variant="h6" textAlign={"center"} >
            {i18n(lang).set_password}
          </Typography>

          <div className="form">
            <br></br>
            <br></br>

            <TextField
              id="outlined-adornment-password"
              name="password"
              fullWidth
              type={values.showPassword ? "text" : "password"}
              label={i18n(lang).password}
              value={values.password}
              onChange={(e) => {
                handleChange(e);
              }}
              variant="outlined"
              helperText={errors.password}
              error={error}
            />

            <br></br>
            <br></br>

            <TextField
              id="outlined-adornment-password"
              name="confirm_password"
              fullWidth
              type={values.showPassword ? "text" : "password"}
              label={i18n(lang).confirm_password}
              value={values.confirmpassword}
              onChange={(e) => {
                handleChange(e);
              }}
              variant="outlined"
              helperText={errors.confirm_password}
              error={error}
            />
          </div>

          <br></br>
          <br></br>

          <Button
            variant="contained"
            color="primary"
            style={{ backgroundColor: "var(--primary-color)"}}
            size="large"
            onClick={handleSubmit}
            className={"loginButton"}
          >
            {i18n(lang).set_password_btn}
          </Button>
        </div>
      </LoginWrapper>
    </>
  );
};

export default SetPassword;
